/* global Swiper */
export default function initDashboard() {
    if (document.querySelector('.page-template-dashboard')) {
        new Dashboard(document.querySelector('.page-template-dashboard'));
    }
}

/**
 * @param {HTMLElement} $el HTML Element
 */
class Dashboard {
    constructor($el) {
        this.$el = $el;
        this.$mobileBreakpoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md')) + 1;
        this.$eventsSwiperWrapper = $el.querySelector('.events-list');
        this.$eventsSwiper = null;

        window.addEventListener('resize', this.initEvents.bind(this));
       
        this.init();
        this.initEvents();
    }
    /**
     *
     * @return {void}
     */
    init() {
        new Swiper('.swiper.referents', {
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }

    initEvents() {
        if (this.$eventsSwiperWrapper) {
            if (this.$eventsSwiper && window.innerWidth > this.$mobileBreakpoint) {
                // Détruit le swiper s'il est déjà créé et qu'on est au dessus du breakpoint MD
                this.destroySwiper();
            } else if (!this.$eventsSwiper && window.innerWidth <= this.$mobileBreakpoint) {
                // Créé le swiper s'il n'est pas déjà créé et q'uon est au dessous du breakpoint MD
                this.createSwiper();
            }
        }
    }

    /**
     * Creer le slider
     *
     * @return {void}
     */
    createSwiper() {
        this.$eventsSwiperWrapper.classList.add('swiper');
        this.$eventsSwiperWrapper.querySelector('.wrapper').classList.add('swiper-wrapper');
        this.$eventsSwiperWrapper.querySelectorAll('.event').forEach(ele => {
            ele.classList.add('swiper-slide');
        });
        
        this.$eventsSwiper = new Swiper(this.$eventsSwiperWrapper, {
            pagination: {
                el: '.swiper-pagination-events',
                clickable: true,
            },
        });
    }

    /**
     * Détruire le slider
     *
     * @return {void}
     */
    destroySwiper() {
        this.$eventsSwiperWrapper.classList.remove('swiper');
        this.$eventsSwiperWrapper.querySelector('.wrapper').classList.remove('swiper-wrapper');
        this.$eventsSwiperWrapper.querySelectorAll('.event').forEach(ele => {
            ele.classList.remove('swiper-slide');
        });

        this.$eventsSwiper.destroy(true, true);
        this.$eventsSwiper = null;
    }
}
